module.exports = __webpack_public_path__ + "img/character@2x.f36a9b08.png";